import * as React from 'react'
// styles
import './styles.css'
import TeamGrid from './components/TeamGrid'
import Glow from '../../glows'

const TeamSection = ({ withDescription }) => (
  <section className='team-section'>
    <div className='box'>
      <Glow />
      <h2 className='main-title'>About</h2>
      <p className='team-about-notice'>
        Pod’s core deterministic intelligence architecture and structured
        dataset systems are protected by multiple USPTO-filed provisional
        patent applications (2026) and a growing trademark portfolio covering
        its core platform modules.
      </p>
      <h2 className='main-title'>Team</h2>
      <TeamGrid withDescription={withDescription} />
    </div>
  </section>
)

export default TeamSection
